import React from 'react';
import AnimateIn from './AnimateIn';
import './About.css';

const About = ({ title, description, imageUrl, points }) => {
  const defaultImage = 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&q=80';
  const defaultTitle = 'About InfinySkills';
  const defaultDescription = 'We believe in empowering learners with practical skills and knowledge. Our platform brings together experts and learners to create meaningful growth.';
  const defaultPoints = [
    'Expert-led courses across multiple domains',
    'Hands-on projects and real-world applications',
    'Flexible learning paths that fit your schedule',
    'Community support and peer learning',
  ];

  const items = points || defaultPoints;

  return (
    <section className="about" id="about">
      <div className="about-container">
        <AnimateIn direction="left" className="about-image-wrap">
          <img src={imageUrl || defaultImage} alt="About us" className="about-image" loading="lazy" />
        </AnimateIn>
        <AnimateIn direction="right" className="about-content">
          <h2 className="about-title">{title || defaultTitle}</h2>
          <p className="about-description">{description || defaultDescription}</p>
          <ul className="about-points">
            {items.map((point, i) => (
              <li key={i}>{point}</li>
            ))}
          </ul>
        </AnimateIn>
      </div>
    </section>
  );
};

export default About;
